import { EyeIcon, StarIcon } from "@heroicons/react/outline";
import {
  ButtonBase,
  TwoColumnSectionBase,
  ImageOverlay,
  BadgeBase,
} from "@reusejs/react";
import { amountFormatter, getWatermarkedImgixUrl } from "services";
import { useRouter } from "next/router";
import { DateTime } from "luxon";
import BlueIcon from "../../../Icons/BlueIcon";
import GreenIcon from "../../../Icons/GreenIcon";

export interface PropertyCardProps {
  onClick?: any;
  borderClasses?: any;
  top?: boolean;
  widthClasses?: any;
  property: any;
}

export default function EnquiredPropertyCard(props: PropertyCardProps) {
  const router = useRouter();

  const getDateAndTime = () => {
    let time;
    if (props.property.preferred_time) {
      time = JSON.parse(props.property.preferred_time).value;
    }
    if (props.property?.preferred_date) {
      return `${time} , ${DateTime.fromISO(props.property.preferred_date)
        .setZone("Asia/Kolkata")
        .toFormat("dd MMMM yyyy")}`;
    }
  };
  const current_date_object = DateTime.now().setZone("Asia/Kolkata").set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const preferred_date_object = DateTime.fromISO(
    props.property?.preferred_date && props.property?.preferred_date,
  ).setZone("Asia/Kolkata");

  const diffDays = Math.floor(
    preferred_date_object.diff(current_date_object, "days").days,
  );

  console.log("check here diffDays", diffDays);

  return (
    <TwoColumnSectionBase
      firstColumnEl={<Image {...props} />}
      secondColumnEl={
        <>
          <TwoColumnSectionBase
            firstColumnEl={<Content {...props} />}
            secondColumnEl={<Action {...props} />}
            twoColumnSectionBaseClasses={{
              firstElWrapperStyles: "md:w-3/5",
              secondElWrapperStyles:
                "w-full md:w-2/5 border-l self-stretch p-4",
              columnsFlexWrapperStyles:
                "flex sm:items-start justify-between flex-col md:flex-row",
            }}
          />
          {diffDays >= 0 ? (
            <div className="px-4 py-3.5 bg-blue-600 rounded-br-lg flex items-baseline">
              <div className="text-white text-sm mr-4">Call scheduled</div>
              <div className="text-white text-[10px]">{getDateAndTime()}</div>
            </div>
          ) : (
            <div className="px-4 py-3.5 bg-gray-100 rounded-br-lg flex items-baseline">
              <div className="text-[#233876] text-sm mr-4">Last enquiry</div>
              <div className="text-[#233876] text-[10px]">
                {getDateAndTime()}
              </div>
            </div>
          )}
        </>
      }
      twoColumnSectionBaseClasses={{
        firstElWrapperStyles: "w-full md:w-1/4 md:h-[299px] overflow-hidden",
        secondElWrapperStyles: "w-full md:w-3/4 self-stretch",
        columnsFlexWrapperStyles:
          "flex items-start justify-between border shadow rounded-lg flex-col md:flex-row",
      }}
    />
  );
}
const Image = (props: any) => {
  return (
    <div className="relative rounded-t-lg sm:rounded-tr-none sm:rounded-l-lg overflow-hidden">
      {props.property?.property?.images &&
      props.property?.property?.images.length > 0 ? (
        <ImageOverlay
          src={getWatermarkedImgixUrl(
            `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${props.property?.property?.images[0].key_path}?fit=crop&w=224&h=299&auto=format`,
          )}
          width={224}
          height={299}
          placeholderSrc={
            props.property?.property?.asset?.name === "residential"
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=224&h=299&auto=format`,
                )
              : props.property?.property?.asset?.name === "commercial"
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=224&h=299&auto=format`,
                )
              : getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=224&h=299&auto=format`,
                )
          }
          topLeft={
            <BadgeBase
              label={props.property?.property?.asset?.name}
              badgeBaseClasses={{
                padding: "px-2 py-0.5",
                backgroundColor:
                  props.property?.property?.asset?.name === "residential"
                    ? "bg-green-100"
                    : props.property?.property?.asset?.name === "commercial"
                    ? "bg-red-100"
                    : "bg-yellow-100",
                textColor:
                  props.property?.property?.asset?.name === "residential"
                    ? "text-green-800"
                    : props.property?.property?.asset?.name === "commercial"
                    ? "text-red-800"
                    : "text-yellow-800",
                font: "text-xs font-small",
                borderRadius: "rounded-md",
              }}
            />
          }
          topRight={
            <StarIcon
              width="24"
              height="24"
              className="text-yellow-300"
              fill="currentColor"
            />
          }
          altName={
            props.property?.property?.asset?.name === "residential"
              ? `residential-${props.property?.property?.images[0].key_path}`
              : props.property?.property?.asset?.name === "commercial"
              ? `commercial-${props.property?.property?.images[0].key_path}`
              : `industrial-${props.property?.property?.images[0].key_path}`
          }
        />
      ) : (
        <ImageOverlay
          src={
            props.property?.property?.asset?.name === "residential"
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=224&h=299&auto=format`,
                )
              : props.property?.property?.asset?.name === "commercial"
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=224&h=299&auto=format`,
                )
              : getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=224&h=299&auto=format`,
                )
          }
          width={224}
          height={299}
          topLeft={
            <BadgeBase
              label={props.property?.property?.asset?.name}
              badgeBaseClasses={{
                padding: "px-2 py-0.5",
                backgroundColor:
                  props.property?.property?.asset?.name === "residential"
                    ? "bg-green-100"
                    : props.property?.property?.asset?.name === "commercial"
                    ? "bg-red-100"
                    : "bg-yellow-100",
                textColor:
                  props.property?.property?.asset?.name === "residential"
                    ? "text-green-800"
                    : props.property?.property?.asset?.name === "commercial"
                    ? "text-red-800"
                    : "text-yellow-800",
                font: "text-xs font-small",
                borderRadius: "rounded-md",
              }}
            />
          }
          topRight={
            <StarIcon
              width="24"
              height="24"
              className="text-yellow-300"
              fill="currentColor"
            />
          }
          altName={
            props.property?.property?.asset?.name === "residential"
              ? "residential-auction-property"
              : props.property?.property?.asset?.name === "commercial"
              ? "commercial-auction-property"
              : "industrial-auction-property"
          }
        />
      )}
    </div>
  );
};

const Content = (props: any) => {
  const current_date_object = DateTime.now().setZone("Asia/Kolkata").set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const emd_last_date_object = DateTime.fromISO(
    props.property?.property.emd_last_date &&
      props.property.property.emd_last_date,
  ).setZone("Asia/Kolkata");

  const diffDays = Math.floor(
    emd_last_date_object.diff(current_date_object, "days").days,
  );

  return (
    <div className="flex-1">
      <div className="text-left px-4 py-2 border-b text-xs text-gray-500">
        Assets ID: {props.property?.property?.listing_id}
      </div>
      <div className="text-left border-b px-4 py-4 flex justify-between h-20">
        <div className="flex basis-1/2 flex-col">
          <div className="text-xs text-gray-500">
            {props.property?.property?.city?.name}
          </div>
          <div className="text-sm">{props.property?.property?.state?.name}</div>
        </div>
        <div className="flex basis-1/2 flex-col pl-6">
          <div>
            {props.property?.property?.bank?.name && (
              <div className="text-xs flex items-center text-gray-500">
                <BlueIcon /> {props.property?.property?.bank?.name}
              </div>
            )}
            {props.property?.property?.ab_verified && (
              <div className="text-xs flex items-center text-blue-600">
                <GreenIcon />
                Verified by Auction Bazaar
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="text-left border-b px-4 flex justify-between">
        <div className="flex basis-1/2 border-r py-4 flex-col">
          <div className="text-xs text-gray-500">Auction Date</div>
          <div className="text-sm">
            {" "}
            {props.property?.property?.property_date_type === "undated" ? (
              <span className="text-red-600">Coming Soon</span>
            ) : props.property?.property?.property_date_type ===
              "private_treaty" ? (
              <span className="text-green-600">Private Treaty</span>
            ) : (
              props.property?.property?.auction_start_date_time &&
              DateTime.fromISO(
                props.property?.property?.auction_start_date_time,
              )
                .setZone("Asia/Kolkata")
                .toFormat("dd MMMM yyyy")
            )}
          </div>
        </div>
        <div className="flex basis-1/2 py-4 flex-col pl-6">
          <div className="text-xs text-gray-500">EMD Amount</div>
          <div className="text-sm">
            {props.property?.property?.property_date_type === "undated" ? (
              <span className="text-red-600">Coming Soon</span>
            ) : props.property?.property?.property_date_type ===
              "private_treaty" ? (
              <span className="text-green-600">Private Treaty</span>
            ) : (
              `₹${amountFormatter(props.property?.property?.emd_amount)}`
            )}
          </div>
        </div>
      </div>
      <div className="text-left border-b px-4 py-2 bg-gray-100 flex justify-between items-center">
        <div className="flex flex-col">
          <div className="text-xs text-[#575D68]">
            {`${
              props.property?.property.interested_count === 0
                ? props.property?.property.interested_count
                : props.property?.property.interested_count + "+"
            } People are interested`}
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex items-center text-xs text-blue-600">
            <EyeIcon width="20" height="20" className="mr-1" />
            {`${
              props.property?.property.view_count === 0
                ? props.property?.property.view_count
                : props.property?.property.view_count + "+"
            } Views`}
          </div>
        </div>
      </div>
      <div className="text-left px-4 py-2 bg-red-100 flex justify-between items-center">
        {props.property?.property?.property_date_type === "dated" ? (
          <div className="flex">
            {diffDays > 0 ? (
              <div className="text-xs text-[#C81E1E]">
                EMD Deposit ends in{" "}
                <span className="font-semibold">{diffDays} Days</span>!
              </div>
            ) : diffDays === 0 ? (
              <div className="text-xs text-[#C81E1E]">
                EMD Deposit ends <span className="font-semibold">Today</span>!
              </div>
            ) : (
              <div className="text-xs text-red-500">
                EMD deposit deadline has ended.
              </div>
            )}
          </div>
        ) : (
          <div className="flex">
            <div className="text-xs text-red-100">.</div>
          </div>
        )}
      </div>
    </div>
  );
};

const Action = (props: any) => {
  const router = useRouter();

  return (
    <div className="flex flex-col h-full justify-between">
      <div>
        <div className="text-left flex justify-between">
          <div className="flex basis-1/2 flex-col">
            <div className="text-base text-gray-500">Reserve Price</div>
            <div className="text-2xl font-bold text-blue-600">
              {/* ₹{amountFormatter(props.property?.property?.reserve_price)} */}
              {props.property?.property?.property_date_type === "undated" ? (
                <div
                  className="cursor-pointer text-xl hover:text-blue-700"
                  onClick={() => {
                    const baseurl = window.location.href
                      .split("/")
                      .filter(Boolean)[1];
                    const link =
                      "https://" +
                      baseurl +
                      "/auction-properties/" +
                      props?.property?.property.listing_id;

                    window.open(
                      `https://wa.me/918370969696?text=${encodeURI(
                        `Hello, I would like to know the price of this property: ${link}`,
                      )}`,
                      "_blank",
                    );
                  }}
                >
                  Contact Us
                </div>
              ) : (
                `₹${amountFormatter(props.property?.property?.reserve_price)}`
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <ButtonBase
          variant="primary"
          type="submit"
          label={"Need help"}
          onClick={() => console.log("Help needed!!!")}
          buttonBaseClasses={{
            font: "text-base font-medium",
            backgroundColor: "bg-transparent",
            textColor: "text-gray-900 hover:text-blue-600",
            border: "border border-gray-900 hover:border-blue-600",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
        <ButtonBase
          variant="primary"
          type="submit"
          label={"View Details"}
          onClick={() =>
            router.push(
              `/auction-properties/${props.property?.property?.listing_id}`,
            )
          }
          buttonBaseClasses={{
            font: "text-base font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
      </div>
    </div>
  );
};
